import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { StateService } from '@uirouter/angular';

@Component({
  selector: 'tracker-query-list-paging',
  template: require('./tracker.query.list.paging.component.html')
})
export class TrackerQueryListPagingComponent implements OnInit {
  @Input() project: any;
  @Input() queries: any[];

  @Output() updatePaging: EventEmitter<any> = new EventEmitter<any>();
  @Output() onRefresh: EventEmitter<any> = new EventEmitter<any>();

  stateService: StateService;

  constructor(stateService: StateService) {
    this.stateService = stateService;
  }

  ngOnInit() {}

  onPageUpdate(paging: any) {
    this.updatePaging.emit(paging);
  }

  refresh() {
    this.onRefresh.emit();
  }
}
